import gql from 'graphql-tag';

export const invalidateCloudFront = gql`
  mutation invalidateCloudFront($path: String!) {
    invalidateCloudFront(path: $path)
  }
`;

export const uploadUserAvatar = gql`
  mutation uploadUserAvatar(
    $email: String!
    $fileBase64: String!
    $mimetype: String!
  ) {
    uploadUserAvatar(
      email: $email
      fileBase64: $fileBase64
      mimetype: $mimetype
    ) {
      success
      errorCode
    }
  }
`;
